var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33333C4.32016 1.33333 1.3335 4.31999 1.3335 8C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8C14.6668 4.31999 11.6802 1.33333 8.00016 1.33333ZM8.66683 12.6667H7.3335V11.3333H8.66683V12.6667ZM10.0468 7.5L9.44683 8.11333C8.96683 8.6 8.66683 9 8.66683 10H7.3335V9.66666C7.3335 8.93333 7.6335 8.26666 8.1135 7.77999L8.94016 6.93999C9.18683 6.7 9.3335 6.36666 9.3335 6C9.3335 5.26666 8.7335 4.66666 8.00016 4.66666C7.26683 4.66666 6.66683 5.26666 6.66683 6H5.3335C5.3335 4.52666 6.52683 3.33333 8.00016 3.33333C9.4735 3.33333 10.6668 4.52666 10.6668 6C10.6668 6.58666 10.4268 7.12 10.0468 7.5Z",
    fill: "#3532F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.7de66df63ceeb72399e625d5eefd3b61.svg";
export { ForwardRef as ReactComponent };